import { BaseModel } from "ReduxStore/index";

export interface ClaimIds {
  claimIds: number[];
}

export default class SortedClaimedIds extends BaseModel<ClaimIds> {
  static resource = "SortedClaimedIds";
}
